import { Component, OnInit, AfterViewInit ,ViewChild} from '@angular/core';
import { ActionSheetController,IonInfiniteScroll } from '@ionic/angular';
import { GridBaseCase } from '../grid.base.case';
import { WebParameterContext } from '../../../../model/common';
import { Platform } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { NativeService } from '../../../../service/native.service';
import { BaseCase } from '../../../basecase';
declare var app;
declare var cordova: any;
@Component({
  selector: 'app-sfa-list-img-collection',
  templateUrl: './sfa-list-img-collection.component.html',
  styleUrls: ['./sfa-list-img-collection.component.scss']
})
export class SfaListImgCollectionComponent extends GridBaseCase implements AfterViewInit {

  // arrayData: Array<any> = [];
  // dataArrayList: Array<any> = [];
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  erraMsg: any = null;
  uploadNum: any = [];
  RecordCount: Number = 0;//列表总数量
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase,
    public actionSheetController: ActionSheetController,
    public native: NativeService
  ) { super(); }
  

  ngAfterViewInit() {
    this.baseService.arrayData = [];

  }
  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.baseService.arrayData.length) {
      that.infiniteScroll.disabled = true;
    } else {
      that.PageNumber++;
      this.LoadData(that.PageNumber);
    }
  }
  btnEvent(n) {
    this.baseService.arrayData.forEach((item, i) => {
      item['isCheck'] = false;
      i == n ? item['isCheck'] = true : item['isCheck'] = false;
      if (item.isCheck) {

      }
    });

  }
  LoadData(PageNumber) {
    let that = this;
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    // console.log(that.com.GetStorageKey("tbstore"));
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    const pageid = that.activaRouter.snapshot.paramMap.get('id');
    
    if(localStorage.getItem("remark")){
      that.erraMsg=localStorage.getItem("remark");
      if(document.getElementsByName("save_img")[0]){
        if(that.erraMsg.indexOf('失败')>=0){
          document.getElementsByName("save_img")[0].style.display="block";
        }else{
          document.getElementsByName("save_img")[0].style.display="none";
        }
      }
      localStorage.removeItem("remark");
     }
    let body = new WebParameterContext();
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    }
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = 10;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    // body.SpecialParameter="ProductBrand";
    // if(pageid){
      body.RequestBody={};
       body.RequestBody.userId=that.com.GetAccount.Id;
      if(that.com.GetStorageKey("tbstore").ID){
        body.RequestBody.storeid=that.com.GetStorageKey("tbstore").ID;//门店名称
      }
      body.RequestBody=JSON.stringify(body.RequestBody);
      // body.RequestBody=JSON.stringify({"b_FK_SystemUser_ID":that.com.GetAccount.Id});
    // }
    that.http.post(app.DEFAULTURL, body).then(data => {
         /****判断是否第一页begin****/
         if(PageNumber == 1){
          that.baseService.arrayData = [];
          that.apiObj['status'] = data.ResponseMessage.Success;
          that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
          that.loading = true;
        }else{
          that.infiniteScroll.complete();
        }
        /****判断是否第一页end****/
      setTimeout(function () {
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      });
      if (data.ResponseMessage.Success) {
        data.Status.Datas.forEach(function (item) {
          let objfield = {};
          that.element.selectItemList.selectItem.forEach((element, index) => {
            if (element.bindingField) {
              objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
            }
          });
          // objfield["pic"] = { "value": [] };
          // if(objfield["img"].value){
          //   let arrayimg = objfield["img"].value.split(',');
          //   arrayimg.forEach((itemimg,index)=>{
          //     let img={};
          //     img["new"] = itemimg;
          //     img["old"] = app.UPLOADREADURL + itemimg + "&size=o";
          //     img["pre"]= app.UPLOADREADURL + itemimg + "&size=t";
          //     objfield["pic"].value.push(img);
          //   });
          // }
         
          that.baseService.arrayData.push(objfield);
          // console.log(that.element.selectItemList.selectItem);
          // console.log( that.baseService.arrayData);
        });
          /****上拉加载数据begin****/
          that.RecordCount = data.Status.RecordCount;
          if(that.RecordCount == data.Status.Datas.length || that.RecordCount == that.baseService.arrayData.length){
            that.infiniteScroll.disabled = true;
          }else{
            that.infiniteScroll.disabled = false;
          }
          /****上拉加载数据end****/
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    })
  }
  BindFirstData() {
    let that = this;
    that.loading = false;
    that.apiObj['status'] = false;
    that.apiObj['msg'] = '';
    
    // console.log(that.com.GetStorageKey("tbstore"));
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    }
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = 10;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    that.http.post(app.DEFAULTURL, body).then(data => {
      that.baseService.arrayData = [];
      setTimeout(function () {
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      });
      if (data.ResponseMessage.Success) {
        data.Status.Datas.forEach(function (item) {
          let objfield = {};
          that.element.selectItemList.selectItem.forEach((element, index) => {
            if (element.bindingField) {
              objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
            }
          });
          objfield["pic"] = { "value": [] };
          that.baseService.arrayData.push(objfield);
          // console.log(that.element.selectItemList.selectItem);
          // console.log( that.baseService.arrayData);
        });
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    })
  }
  BindInit(): Promise<any> {
    let that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.ConfigName = "TBProductCheckMasterXML";//总表
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = 1;
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    if (!that.com.GetAccount.IsAdmin) {
    }
    let _obj = {};
    _obj["b_FK_SystemUser_ID"] = that.com.GetAccount.Id;
    _obj["b_FK_TBStore_ID"] = that.com.GetStorageKey("tbstore")["ID"];
    _obj["b_TaskDate"] = that.com.getNow;
    body.RequestBody = JSON.stringify(_obj);
    return new Promise<any>((resolve, reasole) => {
      that.http.post(app.DEFAULTURL, body).then(data => {
        console.log(data);
        that.baseService.arrayData = [];
        if (data.ResponseMessage.Success) {
          resolve(data.Status);
        } else {
          reasole(data);
        }
      }).catch(error => {
        reasole(error);
      });
    });
  }
  /**
   * 上传图片
   * @param pindex 产品品牌下标
   * @param index 图片下标,做数据预览时使用
   */
  EventPicImg(pindex, index) {
    const that = this;
    cordova.plugins.camera.tackCamera("硬件互调SDK", function (data) {
      if (!data || data == 'null') {
        that.msg.Show("上传图片不能为空");
        return
      }
      let imgarray: any = data.replace('[', '').replace(']', '');
      let arrayimg: Array<any> = imgarray.split(',');
      let guidmax = parseInt(that.element.max) || 0;
      // if (that.baseService.arrayData[pindex]['pic'].value.length + arrayimg.length > guidmax) {
      //   that.msg.Show("上传图片超过" + that.element.max + "张");
      //   return;
      // }
      that.baseService.arrayData[pindex]['pic']["uploadNum"] = arrayimg;
      arrayimg.forEach((img) => {
        let ut = {};
        // ut["new"]=img;
        // ut["old"]=img;
        // that.baseService.arrayData[pindex]['pic'].value.push(ut);
        //上传照片
        that.native.UploadFile(img.trim()).then((imgdata) => {
          if (imgdata.ResponseMessage.Success) {
            that.baseService.arrayData[pindex]['pic']["uploadNum"].splice(0,1);
            ut["new"] = imgdata.Status[0].FileName;
            ut["old"] = app.UPLOADREADURL + imgdata.Status[0].FileName + "&size=o";
            ut["pre"]= app.UPLOADREADURL + imgdata.Status[0].FileName + "&size=t";
            that.baseService.arrayData[pindex]['pic'].value.push(ut);
          }
        });
      });
      // if(that.arrayData.length>0){
      //   let imgdatas:Array<any>=[];
      //   that.arrayData.forEach((newimg)=>{
      //     imgdatas.push(newimg.new);
      //   });
      // that.group.controls[that.config.name].setValue(imgdatas.toString());
      // }
    }, function (msg) {
      console.log(msg);
    })

    // that.native.getCameraPicture().then((pic) => {
    //   let arrayimg: Array<any> = [];
    //   arrayimg.push(pic);
    //   arrayimg.push(pic);
    //   arrayimg.push(pic);
    //   console.log(arrayimg, "pic");
    //   // that.uploadNum = arrayimg;
    //   that.baseService.arrayData[pindex]['pic']["uploadNum"] = arrayimg;
    //   arrayimg.forEach((item, index) => {

    //     that.native.UploadPictures(pic).then(imgdata => {
    //       console.log(imgdata, "imgdata");
    //       let ut = {};
    //       if (imgdata.ResponseMessage.Success) {
    //         setTimeout(()=>{
    //           that.baseService.arrayData[pindex]['pic']["uploadNum"].splice(0,1);
    //         // console.log("上传" + body);
    //         ut["new"] = imgdata.Status[0].FileName;
    //         ut["old"] = app.UPLOADREADURL + imgdata.Status[0].FileName + "&size=o";
    //         ut["pre"]= app.UPLOADREADURL + imgdata.Status[0].FileName + "&size=t";
    //         that.baseService.arrayData[pindex]['pic'].value.push(ut);
    //       },2000);
    //       }
    //     })
    //   })

    // }).then(err => {
    //   that.msg.Alert("请在app中操作");
    // });
  }
  async EditImg(pindex, index) {
    const that = this;
    const pageType = that.activaRouter.snapshot.paramMap.get('type');
    if(pageType=="view"){
      that.ImgPreview(pindex, index);
      return;
    }
    const actionSheet = await this.actionSheetController.create({
      // header: '',
      buttons: [{
        text: '预览',
        handler: () => {
          console.log('预览');
          that.ImgPreview(pindex, index);
        }
      }, {
        text: '删除',
        handler: () => {
          that.baseService.arrayData[pindex]['pic'].value.splice(index, 1);
        }
      }, {
        text: '取消',
        role: 'cancel',
        handler: () => {
          console.log('Cancel clicked');
        }
      }]
    });
    await actionSheet.present();
  }

  ImgPreview(o, index) {
    let that = this;
    const url = [];
    that.baseService.arrayData[o]['pic'].value.forEach(item => {
      url.push(app.UPLOADREADURL + item.new + "&size=o");
    });
    let ImgPreview = {
      imgUrl: url,
      index: index
    }
    // that.router.navigate(["/tabs/contact/ImgPreview"],{
    //   queryParams:{
    //     ImgPreview:JSON.stringify(ImgPreview)
    //   }
    // });
    that.com.Go("/tabs/contact/ImgPreview",{
      ImgPreview:JSON.stringify(ImgPreview)
    });
  }
  EventLink(ev: any, parms: any){
    const that =this;
    console.log("555555555555");
    let evs = ev.url || '';
    // console.log(evs, parms);
    if (evs.trim() && parms) {
      // if(parms["fk_store_id"]){
      //   localStorage.setItem("tbstore",JSON.stringify({"ID":parms["fk_store_id"].value}));
      // }
      if (evs.indexOf("http") > 0) {
        if(parms.title){
          this.com.goWebPage(evs,parms.title);
        }else{

        }
        // console.log(evs, parms);
      } else {
        let _temp={};
        _temp["ID"]= parms.ID.value;
        _temp["Name"]= parms.name.value;
        localStorage.setItem("brand",JSON.stringify(_temp));
        if(parms.count.value){
          this.com.setHistoryUrl();
          if(parms.count.value==200){
             this.com.Go("/tabs/contact/RowInspectionResult/add/" + parms.taskid.value);
          }else{
            if(parms.count.value==100 || parms.count.value==207){//识别中/拼接中
              localStorage.setItem("bardagecount",parms.count.value);//判断识别是否是识别失败；
            }else{
              localStorage.removeItem("bardagecount");
              localStorage.setItem("bardage",parms.remark.value);//判断识别是否是识别失败；
            }
            //  this.router.navigate([evs +"/add/" + parms.ID.value+"&"+parms.count.value]);
             this.com.Go(evs +"/add/" + parms.ID.value+"&"+parms.count.value);
          }
        }else{
          this.com.Go(evs +"/add/" + parms.ID.value+"&"+that.com.getNowDatetime);
        }
        

      }
  }
}

}
